export const CURATION_ATOM_KEYS = {
  STORE_CURATION: 'curation',
  STORE_CURATION_LOADING: 'curation_loading',
  STORE_CURATION_VISIBLE: 'curation_visible',
} as const
